module.exports = __webpack_public_path__ + "img/create-your-own.5e73851.png";